import React from 'react';
import { filterConfirmedUsers } from '../../utils/userSelectorQueries';
import { UserDetailsDto } from '../../../../services/User/userService.dto';
import UserSelector from './UserSelector';
import { SelectedUserType } from './userSelectorTypes';

interface Props {
  user?: SelectedUserType;
  onUserSelected: (user?: UserDetailsDto) => void;
}

const ConfirmedUserSelector = ({ user, onUserSelected }: Props) => {
  return <UserSelector user={user} onUserSelected={onUserSelected} filterUsers={filterConfirmedUsers} />;
};

export default ConfirmedUserSelector;
